<template>
  <v-dialog v-model="isVisible" max-width="350px" class="text-center" scrollable>
    <v-card class="pa-4 text-center">
      <v-card-title class="justify-center mb-3">
        <span class="text-h5 font-weight-bold">{{ title }}</span>
      </v-card-title>
      <v-card-text class="text-center" style="max-height: 50vh; overflow-y: auto;">
        <VueQrcode 
          :value="qrValue" 
          :options="qrOptions"
          class="mx-auto"
        ></VueQrcode>
        <div class="text-body-1 font-weight-6 my-1" v-if="showValue">{{ displayValue || qrValue }}</div>
        <small class="font-weight-5 pb-4" v-if="displayAttr">{{ displayAttr }}</small>
        <div class="text-body-2 mt-3" v-if="subtitle">{{ subtitle }}</div>
        <div class="text-caption text-left mt-4 px-4" v-if="description" v-html="description.replace(/\n/g, '<br />')"></div>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          class="text-caption font-weight-6 white--text py-4"
          color="tertiary"
          block
          @click="closeModal"
        >
          {{ closeButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
  name: 'QrCodeModal',
  components: {
    VueQrcode,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    qrValue: {
      type: String,
      required: true,
    },
    displayValue: {
      type: String,
      default: '',
    },
    displayAttr: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'QR Code',
    },
    subtitle: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    showValue: {
      type: Boolean,
      default: true,
    },
    closeButtonText: {
      type: String,
      default: 'Close',
    },
    qrOptions: {
      type: Object,
      default: () => ({
        width: 200,
        margin: 2,
      }),
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.closeModal();
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
/* Add any custom styles if needed */
</style> 